import { render, staticRenderFns } from "./ListRelatedFares.vue?vue&type=template&id=6baaaf6b&scoped=true&"
import script from "./ListRelatedFares.vue?vue&type=script&lang=js&"
export * from "./ListRelatedFares.vue?vue&type=script&lang=js&"
import style0 from "./ListRelatedFares.vue?vue&type=style&index=0&id=6baaaf6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baaaf6b",
  null
  
)

export default component.exports